<template>
  <div v-if="requerimientoActual" class="requerimiento-seleccionado">
    <h4 style="margin: 1rem 0 0.5rem 0; color: #007bff;">✅ Requerimiento Seleccionado:</h4>
    <div class="req-selected">
      <div class="req-titulo-selected">{{ requerimientoActual.cc_nombre_requerimiento }}</div>
      <div class="req-info">
        <span><strong>Área:</strong> {{ requerimientoActual.cc_nombre_area }}</span>
        <span><strong>ID:</strong> {{ requerimientoActual.cc_id_requerimientos }}</span>
        <span><strong>Prioridad:</strong> {{ getPrioridadLabel(requerimientoActual.cc_prioridad_requerimiento) }}</span>
      </div>
      <button @click="limpiarSeleccion" class="btn-limpiar">
        ✕ Cambiar requerimiento
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequerimientoSeleccionado',
  props: {
    requerimientoActual: {
      type: Object,
      default: null
    }
  },
  methods: {
    getPrioridadLabel(prioridad) {
      const prioridades = {
        1: '🔴 Alta',
        2: '🟡 Media', 
        3: '🟢 Baja'
      }
      return prioridades[prioridad] || `Prioridad ${prioridad}`
    },
    
    limpiarSeleccion() {
      this.$emit('limpiar-seleccion')
    }
  }
}
</script>

<style scoped>
.requerimiento-seleccionado {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #e8f4fd, #d1ecf1);
  border: 2px solid rgba(0, 123, 255, 0.2);
  border-radius: 16px;
  box-shadow: 
    0 8px 16px rgba(0, 123, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

.requerimiento-seleccionado::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #007bff, #17a2b8);
  border-radius: 16px 16px 0 0;
}

.requerimiento-seleccionado h4 {
  background: linear-gradient(135deg, #007bff, #17a2b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.req-selected {
  position: relative;
  z-index: 2;
}

.req-titulo-selected {
  font-weight: 700;
  background: linear-gradient(135deg, #007bff, #17a2b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.req-info {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.req-info span {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #495057;
  font-weight: 600;
  border: 2px solid rgba(0, 123, 255, 0.1);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
  transition: all 0.3s ease;
}

.req-info span:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  border-color: rgba(0, 123, 255, 0.2);
}

.req-info span strong {
  color: #007bff;
  font-weight: 700;
}

.btn-limpiar {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  position: relative;
  overflow: hidden;
}

/* 🔧 Efecto de brillo en botones removido */

.btn-limpiar:hover {
  background: linear-gradient(135deg, #545b62, #3d4043);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
}

@media (max-width: 768px) {
  .requerimiento-seleccionado {
    padding: 1rem;
    margin-top: 1.5rem;
  }
  
  .req-info {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .req-info span {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }
  
  .req-titulo-selected {
    font-size: 1.1rem;
  }
  
  .btn-limpiar {
    padding: 0.625rem 1.25rem;
    font-size: 0.85rem;
  }
}
</style>
